<template lang="pug">
  div
    .homepage-hero-slideshow
      homepage-slideshow
    .homepage-navigation__container
      homepage-navgiation
    .homepage-blog.mt-5(v-if="recommended_products.length > 0")
      .container
        .row.align-items-center.homepage-blog__header
          .col-12
            h4.homepage-blog__title.mb-0 {{ trans('labels.frontend.homepage.recommended_products') }}
        .row.blog-list.blog-list--no-background.py-0
          blog-item(:post="post" v-for="post in recommended_products" :key="post.ID")
    .homepage-new-products
      .container
        .row.mb-2.mb-lg-4(v-if="new_products && new_products.length > 0")
          .col-6
            h3.homepage-new-products__title {{ trans('labels.frontend.homepage.new_products') }}
        .product-list.row
          product-list-item.col-lg-3.col-md-3.col-6(:product="product" v-for="product in new_products" :key="product.id")
    .homepage-featured-category(
      v-for="featured in sortedFeaturedCategories" v-bind:class="{'homepage-featured-category--slideshow': featured.options.type === 'slideshow'}"
    )
      .container
        .row.align-items-center.mb-3.mb-lg-4
          .col-6
            router-link.d-flex.flex-row.align-items-center(:to="{ name: 'shop.category', params: { slug: featured.category.slug } }")
              img.homepage-featured-category__icon(
                v-if="featured.options.type === 'grid' && featured.category.featured_image"
                :src="featured.category.featured_image"
              )
              h3.homepage-featured-category__title {{ featured.category.name }}
          .col-6.text-right
            router-link.homepage-featured-category__more(
              :to="{ name: 'shop.category', params: { slug: featured.category.slug } }"
            ) ดูทั้งหมด
        .row
          .col-lg-4.col-6(v-if="featured.options.type === 'grid'" v-for="child in featured.category.children" :key="child.id")
            router-link.d-block.mb-3(:to="{ name: 'shop.category.subcategory', params: { slug: featured.category.slug, subCategory: child.slug } }")
              .homepage-featured-category__sub-category
                .row.align-items-center.w-100.no-gutters
                  .col-6
                    h4.homepage-featured-category__sub-category-title {{ child.name }}
                  .col-6.text-right
                    img.homepage-featured-category__sub-category-image(
                      :src="child.featured_image" v-if="child.featured_image"
                    )
          .col-12(v-if="featured.options.type === 'slideshow'")
            swiper.homepage-featured-category__slideshow(
              ref="productCategorySwiper" :options="options.swiperOptions" data-slideout-ignore
            )
              swiper-slide.homepage-featured-category__slide.homepage-featured-category__slide--primary.product-list__item
                router-link.d-flex.flex-column.h-100(:to="{ name: 'shop.category', params: { slug: featured.category.slug } }")
                  .d-flex.flex-column.flex-grow-1
                    img.homepage-featured-category__icon(
                      :src="featured.category.featured_image" v-if="featured.category.featured_image"
                    )
                    h3.homepage-featured-category__title {{ featured.category.name }}
                  .text-right
                    img.homepage-featured-category__image(:src="featured.category.icon" v-if="featured.category.icon")
              swiper-slide.homepage-featured-category__slide(v-for="product in featured.products" :key="product.id")
                .product-list
                  product-list-item(:product="product")
              .swiper-button-prev(slot="button-prev")
                font-awesome-icon(:icon=['far', 'angle-down'])
              .swiper-button-next(slot="button-next")
                font-awesome-icon(:icon=['far', 'angle-down'])
    .homepage-about
      elementor(:object-id='185', object-type='template')
    .homepage-blog
      .container
        .row.align-items-center.homepage-blog__header
          .col-6
            h4.homepage-blog__title.mb-0 {{ trans('labels.frontend.homepage.blog') }}
          .col-6.text-right
            router-link.homepage-blog__view-all(:to="{ name: 'blog.index' }" :title="trans('labels.general.all')") {{ trans('labels.general.all') }}
        .row.blog-list.blog-list--no-background.pt-0
          blog-item(:post="post" v-for="post in posts" :key="post.ID")
    b-modal(ref="promotion-popup" id="promotion-popup" hide-footer hide-header modal-class="modal--promotion-popup" v-if="setting.promotion_popup" centered)
      div.modal-container.text-center
        .modal-close(@click="$bvModal.hide('promotion-popup')")
          font-awesome-icon(:icon="['far', 'times']")
        a(:href="setting.promotion_popup_link || '#'")
          img(:src="setting.promotion_popup")
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { ContentLoader } from 'vue-content-loader';
import matchHeight from 'jquery-match-height';
import BlogItem from './blog/loop/BlogItem.vue';
import HomepageNavgiation from '../components/homepage/HomepageNavgiation.vue';
import HomepageSlideshow from '../components/homepage/HomepageSlideshow.vue';
import ProductListItem from '../components/product/ProductListItem.vue';
import { RepositoryFactory } from '../repositoryFactory';

const BlogRepository = RepositoryFactory.get('blog');
const ProductRepository = RepositoryFactory.get('product');
const ProductCategoryRepository = RepositoryFactory.get('productCategory');
const SettingRepository = RepositoryFactory.get('setting');

import 'swiper/css/swiper.css';

window.matchHeight = matchHeight;

export default {
  components: {
    BlogItem,
    ContentLoader,
    HomepageNavgiation,
    HomepageSlideshow,
    ProductListItem,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      recommended_products: [],
      posts: [],
      new_products: [],
      featured_categories: [],
      setting: {},
      options: {
        swiperOptions: {
          slidesPerView: 2,
          spaceBetween: 15,
          slidesPerGroup: 2,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
            1024: {
              slidesPerView: 5,
              slidesPerGroup: 3,
            }
          }
        },
      }
    };
  },
  watch: {
    $route() {
      this.getSettings();
      this.getRecommendedProducts();
      this.getBlogPosts();
    },
    sortedFeaturedCategories() {
      Vue.nextTick(() => {
        $('.product-list__item').matchHeight();
        // setTimeout(() => $('.product-list__item').matchHeight(), 2000);
      });
    }
  },
  computed: {
    sortedFeaturedCategories() {
      return _.sortBy(this.featured_categories, (featured) => {
        return _.findIndex(this.setting.homepage_featured_categories, (row) => {
          return featured.category.slug === row.slug;
        })
      });
    }
  },
  mounted() {
    this.getSettings();
    this.getRecommendedProducts();
    this.getBlogPosts();

    this.$watch('setting', () => {
      if (typeof this.setting.homepage_new_products !== 'undefined') {
        this.getNewProducts();
      }
      this.getFeaturedCategories();
    }, { deep: true });
  },
  metaInfo() {
    return {
      title: this.setting.seo_homepage_title,
      meta: [{
        name: 'description',
        content: this.setting.seo_homepage_description ?? this.setting.seo_homepage_title,
      }, {
        property: 'og:title',
        content: this.setting.seo_homepage_title ?? '',
      }, {
        property: 'og:description',
        content: this.setting.seo_homepage_description ?? this.setting.seo_homepage_title,
      }],
    };
  },
  methods: {
    async getSettings() {
      const { data } = await SettingRepository.get({
        name: 'homepage_new_products|homepage_featured_categories|seo_homepage_title|seo_homepage_description|promotion_popup|promotion_popup_link',
      });
      this.setting = data;
      this.$nextTick(() => {
        if (!_.isEmpty(this.setting.promotion_popup)) {
          this.$refs['promotion-popup'].show();
        }
      });
    },
    async getNewProducts() {
      const productIds = this.setting.homepage_new_products.split(',');
      const { data } = await ProductRepository.get({ paginated: false, where_in: productIds }).then((resp) => resp.data);
      this.new_products = data;

      Vue.nextTick(() => {
        $('.product-list__item').matchHeight();
      });
    },
    async getFeaturedCategories() {
      _.forEach(this.setting.homepage_featured_categories, async (value) => {
        const category = await ProductCategoryRepository.getBySlug(value.slug, { with: 'children' }).then((resp) => resp.data);
        let products = [];
        if (value.type === "slideshow") {
          const { data } = await ProductRepository.get({
            paginated: false,
            category: value.slug,
            limit: 8
          }).then((resp) => resp.data);
          products = data;
        } else {
          products = []
        }
        this.featured_categories.push({ category: category.data, products: products, options: value });
      });
    },
    async getRecommendedProducts() {
      const { data } = await BlogRepository.post().get({
        sort: 'post_date|desc', limit: 4, published: true, paginated: false, category: 'recommended-products',
      }).then((resp) => resp.data);
      this.recommended_products = data;

      Vue.nextTick(() => {
        $('.blog-list__item-body').matchHeight();
      });
    },
    async getBlogPosts() {
      const { data } = await BlogRepository.post().get({
        sort: 'post_date|desc', limit: 4, published: true, paginated: false, category_not_in: 'recommended-products',
      }).then((resp) => resp.data);
      this.posts = data;

      Vue.nextTick(() => {
        $('.blog-list__item-body').matchHeight();
      });
    },
  },
};
</script>
